import { createFileRoute } from '@tanstack/react-router';
import { NotificationSettings } from '../-components/NotificationSettings';
import { useContext } from 'react';
import { ProfileContext } from '../route';
import { InvestorProfileType } from '@/api/backend/types';

export const Route = createFileRoute('/_auth/profile/investor/_layout/notification-settings')({
  component: RouteComponent,
  context: () => {
    return {
      getBreadcrumbData: () => ({
        id: null,
        translationKey: null,
      }),
    };
  },
});

function RouteComponent() {
  const { profile } = useContext(ProfileContext);
  const investorProfile = profile as InvestorProfileType;

  return <NotificationSettings profile={investorProfile} />;
}
